// extracted by mini-css-extract-plugin
export default {"body":"text-editor_body__XRSi1","title":"text-editor_title__ePH6E","editor":"text-editor_editor__WoxIW"};